export const labelStyles = {
  fontSize: '0.875rem',
  '.MuiInputLabel-asterisk': {
    color: '#d32f2f'
  }
};

export const textFieldStyles = {
  width: '50%',
  '& .MuiOutlinedInput-root': {
    fontSize: '0.875rem'
  },
  '& .MuiOutlinedInput-input': {
    padding: '4px 8px'
  }
};
